<template>
  <v-dialog
    content-class="dialog-fixed-top"
    @keydown.esc="$emit('input', null)"
    :transition="false"
    :value="value"
    @input="(v) => v || $emit('input', null)"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    max-width="600"
  >
    <v-card>
      <ODialogBar
        v-if="$isMobile"
        title="Acesso Rápido"
        @close="$emit('input', null)"
      />

      <v-card-text class="pa-4">
        <v-text-field
          v-model="txtFilter"
          label="Busca Inteligente..."
          @keydown.up.prevent="move(-1)"
          @keydown.down.prevent="move(+1)"
          @keydown.enter.prevent="goSelection()"
          @keydown.page-down.prevent="detailsMode = !detailsMode"
          @keydown.page-up.prevent="detailsMode = !detailsMode"
          hide-details
          ref="theFilter"
        />
      </v-card-text>

      <v-list>
        <BoltDialogItem
          v-for="(item, index) in results"
          :key="index"
          :item="item"
          :isSelected="kbdIndex == index"
          :detailsMode="detailsMode"
          @click="go(item)"
        />
      </v-list>

      <ORow fill-x class="bolt-help">
        <OCol class="oderon-col-4">
          <div class="caption grey--text text--lighten-1">Atalhos</div>
          <ORow left>
            <BookmarkButton />

            <v-btn
              icon
              title="Primeiro pendente de checklist"
              @click="gotoFirstPending"
            >
              <v-icon>mdi-clipboard-check-outline</v-icon>
            </v-btn>
          </ORow>
        </OCol>

        <OCol class="oderon-col-8 pl-2">
          <div class="caption grey--text text--lighten-1">Dicas</div>
          <div>
            <div><code>hb 123</code> vai para este HB</div>
            <div>
              <code>exemplo 123</code> vai para o trecho 123 na org "exemplo"
            </div>
            <div><code>PageDown</code> alterna o modo de detalhes</div>
          </div>
        </OCol>
      </ORow>
    </v-card>
  </v-dialog>
</template>

<script>
import BoltItems from './BoltItems'
import BookmarkButton from './BookmarkButton.vue'
import { InstalledBase } from '@/models'
import BoltDialogItem from './BoltDialogItem.vue'

export default {
  components: {
    BookmarkButton,
    BoltDialogItem
  },
  props: {
    value: {}
  },
  data() {
    return {
      txtFilter: '',
      // allOrgs: [],
      // allClients: [],
      kbdIndex: null,
      detailsMode: false
    }
  },
  watch: {
    value(newVal) {
      this.txtFilter = ''
      this.kbdIndex = null
      if (newVal) setTimeout(() => this.$refs.theFilter.focus(), 100)
    },
    txtFilter() {
      this.kbdIndex = null
    }
  },
  computed: {
    results() {
      return BoltItems.filterItems(this.txtFilter)
    }
  },
  mounted() {
    BoltItems.fetchData()
  },
  methods: {
    go(item) {
      this.$emit('input', null)
      this.$router.push({ path: item.to })
    },
    goSelection() {
      if (this.results.length == 1) {
        this.go(this.results[0])
      } else {
        let item = this.results[this.kbdIndex]
        if (item) this.go(item)
      }
    },
    move(n) {
      if (this.results.length < 1) {
        this.kbdIndex = null
        return
      }

      let min = 0,
        max = this.results.length - 1

      if (this.kbdIndex == null) {
        if (n == +1) this.kbdIndex = 0
        if (n == -1) this.kbdIndex = max
      } else {
        this.kbdIndex += n
        if (this.kbdIndex > max) this.kbdIndex = min // loop
        if (this.kbdIndex < min) this.kbdIndex = max // loop
      }
    },

    async gotoFirstPending() {
      this.$emit('input', null)

      let { rows } = await InstalledBase.getGrid({
        offset: 0,
        limit: 1,
        hideNoVehicle: true,
        onlyPendingChecklists: true,
        vars: 'clientId,vehicleCode,clientLastChecklist',
        order: 'clientLastChecklist asc'
      })

      if (rows.length < 1) {
        this.$snack('Não existem módulos pendentes de checklist.')
      } else {
        let cid = rows[0].cells[0]
        this.$router.push({ path: '/clients/' + cid })
      }
    }
  }
}
</script>

<style>
.bolt-help {
  padding: 16px;
  font-size: small;
  color: #999;
}
</style>
